import { render, staticRenderFns } from "./CartView.vue?vue&type=template&id=56f6e5c6&"
import script from "./CartView.vue?vue&type=script&lang=ts&"
export * from "./CartView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports